const state = {
    isProjectAssociationVisible: false
};

const getters = {
    isProjectAssociationVisible: state => state.isProjectAssociationVisible
};

const mutations = {
    setIsProjectAssociationVisible: (state, data) => state.isProjectAssociationVisible = data
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    strict: false
};